import React, { useState, useEffect } from "react";
import { Menu, X, Instagram, MessageCircle } from "lucide-react";
import MMLogo from "./MMLogo";
import { contact } from "../mock";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { label: "Accueil", href: "#home" },
    { label: "L'institut", href: "#about" },
    { label: "Soins", href: "#soins" },
    { label: "Tarifs", href: "#tarifs" },
    { label: "Produits", href: "#produits" },
    { label: "Infos", href: "#infos" },
    { label: "Contact", href: "#contact" }
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-cream/95 backdrop-blur-md shadow-sm py-3" : "bg-transparent py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between">
        <a href="#home" className="flex items-center gap-3">
          <MMLogo size={40} />
          <div className="leading-tight">
            <div className="font-serif text-[11px] md:text-xs tracking-[0.35em] text-brown">
              MAISON MORGANE
            </div>
            <div className="font-cormorant italic text-[10px] md:text-[11px] tracking-widest text-gold-dark">
              beauté & bien-être
            </div>
          </div>
        </a>

        <div className="hidden lg:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="link-underline text-[11px] tracking-[0.25em] uppercase text-brown hover:text-gold-dark transition-colors"
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href={contact.whatsappUrl}
            target="_blank"
            rel="noreferrer"
            className="btn-outline-gold !py-2 !px-4"
            title={`WhatsApp ${contact.whatsapp}`}
          >
            <MessageCircle size={14} strokeWidth={1.6} />
            WhatsApp
          </a>
          <a
            href={contact.instagramUrl}
            target="_blank"
            rel="noreferrer"
            className="btn-gold"
          >
            <Instagram size={14} strokeWidth={1.6} />
            Réserver
          </a>
        </div>

        <button className="lg:hidden text-brown" onClick={() => setOpen(!open)}>
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-cream border-t border-taupe/40 mt-3">
          <div className="px-8 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-[12px] tracking-[0.25em] uppercase text-brown"
              >
                {l.label}
              </a>
            ))}
            <a
              href={contact.whatsappUrl}
              target="_blank"
              rel="noreferrer"
              onClick={() => setOpen(false)}
              className="btn-outline-gold self-start"
            >
              <MessageCircle size={14} strokeWidth={1.6} />
              Réserver sur WhatsApp
            </a>
            <a
              href={contact.instagramUrl}
              target="_blank"
              rel="noreferrer"
              onClick={() => setOpen(false)}
              className="btn-gold self-start"
            >
              <Instagram size={14} strokeWidth={1.6} />
              Réserver sur Instagram
            </a>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
